/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Checking_InInputs */

const en_verify_checking_in = /** @type {(inputs: Verify_Checking_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking In…`)
};

const es_verify_checking_in = /** @type {(inputs: Verify_Checking_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrando…`)
};

const fr_verify_checking_in = /** @type {(inputs: Verify_Checking_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement en cours…`)
};

const de_verify_checking_in = /** @type {(inputs: Verify_Checking_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird eingecheckt…`)
};

const id_verify_checking_in = /** @type {(inputs: Verify_Checking_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memeriksa Masuk…`)
};

/** @type {(inputs: Verify_Checking_InInputs) => LocalizedString} */
const ja_verify_checking_in = en_verify_checking_in;

/** @type {(inputs: Verify_Checking_InInputs) => LocalizedString} */
const zh_verify_checking_in = en_verify_checking_in;

/** @type {(inputs: Verify_Checking_InInputs) => LocalizedString} */
const ar_verify_checking_in = en_verify_checking_in;

/** @type {(inputs: Verify_Checking_InInputs) => LocalizedString} */
const it_verify_checking_in = en_verify_checking_in;

/** @type {(inputs: Verify_Checking_InInputs) => LocalizedString} */
const ru_verify_checking_in = en_verify_checking_in;

/** @type {(inputs: Verify_Checking_InInputs) => LocalizedString} */
const pt_verify_checking_in = en_verify_checking_in;

/** @type {(inputs: Verify_Checking_InInputs) => LocalizedString} */
const ko_verify_checking_in = en_verify_checking_in;

/**
* | output |
* | --- |
* | "Checking In…" |
*
* @param {Verify_Checking_InInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_checking_in = /** @type {((inputs?: Verify_Checking_InInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Checking_InInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_checking_in(inputs)
	if (locale === "es") return es_verify_checking_in(inputs)
	if (locale === "fr") return fr_verify_checking_in(inputs)
	if (locale === "de") return de_verify_checking_in(inputs)
	if (locale === "ja") return ja_verify_checking_in(inputs)
	if (locale === "zh") return zh_verify_checking_in(inputs)
	if (locale === "ar") return ar_verify_checking_in(inputs)
	if (locale === "id") return id_verify_checking_in(inputs)
	if (locale === "it") return it_verify_checking_in(inputs)
	if (locale === "ru") return ru_verify_checking_in(inputs)
	if (locale === "pt") return pt_verify_checking_in(inputs)
	return ko_verify_checking_in(inputs)
});